const targetAudience = {
  Beginners: 'Za početnike',
  Intermediate: 'Za naprednije',
  Advanced: 'Za iskusne',
  Everyone: 'Za sve',
};

export default targetAudience;
